import { render, staticRenderFns } from "./vertical-manage.vue?vue&type=template&id=5edf5c64&"
import script from "./vertical-manage.vue?vue&type=script&lang=js&"
export * from "./vertical-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports